// extracted by mini-css-extract-plugin
export default {"no-more-trips":"styles_no-more-trips__n1ucv"};